module.exports = __webpack_public_path__ + "img/Partners 3.76f053ff.png";